import { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './auth/AuthContext';
import { useLang } from './i18n/lang';
import { Layout } from './components/Layout';
import { Splash } from './components/Splash';
import { AuthScreen } from './screens/AuthScreen';
import { Dashboard } from './screens/Dashboard';
import { NewProject } from './screens/NewProject';
import { ProjectWorkspace } from './screens/ProjectWorkspace';
import { MappingReview } from './screens/MappingReview';
import { CountSheet } from './screens/CountSheet';
import { LegendLayout } from './screens/LegendLayout';
import { Bom } from './screens/Bom';
import { Costing } from './screens/Costing';
import { Outputs } from './screens/Outputs';
import { Admin } from './screens/Admin';
import { CodesLibrary } from './screens/CodesLibrary';
import { FireAlarmDesigner } from './screens/FireAlarmDesigner';
import { UserGuide } from './screens/UserGuide';
import { Analytics } from './screens/Analytics';
import { ChangePassword } from './components/ChangePassword';

export function App() {
  const { user, loading } = useAuth();
  const { t } = useLang();
  // Opening splash — shown on every fresh page load (initial visit or refresh),
  // before anything else. In-app link navigation doesn't reload the page, so it
  // won't replay while someone is working. Click-to-skip.
  const [splash, setSplash] = useState(true);

  if (splash) {
    return <Splash onDone={() => setSplash(false)} />;
  }
  if (loading) {
    return <div className="auth-wrap"><div className="muted">{t({ en: 'Loading…', fil: 'Naglo-load…' })}</div></div>;
  }
  // After the splash: signed-in users land on the dashboard ("/"); everyone else
  // sees the sign-in / password screen.
  if (!user) return <AuthScreen />;
  // Admin-reset accounts must set a new password before doing anything else.
  if (user.must_change) return <ChangePassword forced />;

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/new" element={<NewProject />} />
        <Route path="/projects/:id" element={<ProjectWorkspace />} />
        <Route path="/projects/:id/mapping" element={<MappingReview />} />
        <Route path="/projects/:id/count" element={<CountSheet />} />
        <Route path="/projects/:id/legend-layout" element={<LegendLayout />} />
        <Route path="/projects/:id/bom" element={<Bom />} />
        <Route path="/projects/:id/costing" element={<Costing />} />
        <Route path="/projects/:id/outputs" element={<Outputs />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/codes" element={<CodesLibrary />} />
        <Route path="/fire-alarm-design" element={<FireAlarmDesigner />} />
        <Route path="/guide" element={<UserGuide lang="en" />} />
        <Route path="/guide/fil" element={<UserGuide lang="fil" />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}
